import { render, staticRenderFns } from "./petEdit.vue?vue&type=template&id=08ddef37&scoped=true&"
import script from "./petEdit.vue?vue&type=script&lang=js&"
export * from "./petEdit.vue?vue&type=script&lang=js&"
import style0 from "./petEdit.vue?vue&type=style&index=0&id=08ddef37&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ddef37",
  null
  
)

export default component.exports